<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false" label="分组Id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input read-only v-decorator="[ 'groupId', validatorRules.groupId]" placeholder="请输入分组id"></a-input>
        </a-form-item>
        <a-form-item label="分组" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readOnly v-decorator="[ 'groupName', validatorRules.groupName]" placeholder="请输入分组"></a-input>
        </a-form-item>
        <a-form-item label="部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag ref="departSelectTag" v-decorator="[ 'groupName', validatorRules.departTempId]"   placeholder="请选择部门"   ></j-dict-select-tag>
        </a-form-item>
        <a-form-item label="车间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'workshopId', validatorRules.workshopId]" placeholder="请输入车间id"></a-input>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: "BusInspectionGroupWorkshopModal",
    components: { 
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          groupId: {rules: [
          ]},
          workshopId: {rules: [
          ]},
        },
        url: {
          add: "/group/busInspectionGroupWorkshop/add",
          edit: "/group/busInspectionGroupWorkshop/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add (record) {
        this.edit(record);
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;

        this.$refs.departSelectTag.setCurrentDictOptions();
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'groupId','workshopId',"groupName"))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'groupId','workshopId'))
      },

      
    }
  }
</script>